<template>
	<div>
		<Titlebar />
		<EventForm v-model="form" @submit="onSubmit" :busy="submitting" />
	</div>
</template>

<script>
import Titlebar from '@/components/Titlebar'
import EventForm from '@/forms/EventForm'
import toast from '@/mixins/toast'
import { competitionForm } from '@/lib/forms'
import { EventProvider } from '@/lib/dataProvider'

export default {
	name: 'CreateCompetition',
	data() {
		return {
			submitting: false,
			form: competitionForm(),
		}
	},
	methods: {
		async onSubmit() {
			if (!this.submitting) {
				this.submitting = true
				try {
					// Create competition
					const event = await EventProvider.create(this.form)
					this.toast(`Successfully created the *${event.name}* competition.`)

					// Go to management page
					this.$router.push({ name: 'Manage Competitions' })
				} catch (err) {
					this.toastError(err.message || 'Failed to create the competition.')
				}
				this.submitting = false
			}
		},
	},
	mixins: [toast],
	components: {
		Titlebar,
		EventForm,
	},
}
</script>
